import { defineMessages } from 'src/i18n';

export const messages = defineMessages({
  alertInvalidAddress: {
    id: 'signup.alert.invalidAddress',
    defaultMessage: 'Your billing address must include state, zip code and country.'
  }
});
